import { createStore, getActionIds } from '../helpers/redux';
import Immutable, { Map } from 'immutable';
import { ProjectActions } from '../actions/project';

const projectActions = getActionIds(ProjectActions);

const initialState = Immutable.fromJS({
  timezones: {},
  loadingAll: false,
  loadedAll: false,
});

export const timezones = createStore(initialState, {
  [projectActions.resetReducers]: (state, action) => {
    return initialState;
  },

  [projectActions.getProject.success]: (state, action) => {
    return state.mergeDeep({
      timezones: action.result.entities["Time Zone"],
    });
  },

  [projectActions.getTimezones.begin]: (state, action) => {
    return state.mergeDeep({
      loadingAll: true,
      loadedAll: false,
    });
  },

  [projectActions.getTimezones.failure]: (state, action) => {
    return state.mergeDeep({
      loadingAll: false,
      loadedAll: false,
    });
  },

  [projectActions.getTimezones.success]: (state, action) => {
    return state.mergeDeep({
      loadingAll: false,
      loadedAll: true,
      timezones: action.result.entities["Time Zone"],
    });
  },
});

export const timezonesSelector = state => state.timezones.get('timezones', Map());

export const getTimezoneOffset = (timezones, timezoneId) => {
  return timezones.getIn([timezoneId, 'offset'], '-4.00');
}

export const shouldLoadTimeZonesSelector = state => {
  return !state.timezones.get('loadedAll') && !state.timezones.get('loadingAll');
}



// WEBPACK FOOTER //
// ./src/reducers/timezones.js